import { ServiceFetch } from '../service-fetch'

export default class ProductInitModel extends ServiceFetch {
    getLineChannelBy = (data) => this.authFetch({
        url: 'line-channel/getLineChannelBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updateLineChannelByCode = (data) => this.authFetch({
        url: 'line-channel/updateLineChannelByCode',
        method: 'POST',
        body: JSON.stringify(data),
    })
}